/**
 * 员工模糊查询
 */
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { getEmployee } from '@/common/api/employee';
import Fuzzy from '@/common/components/Select/Fuzzy';
import { isArray } from '@lhb/func';

const UserList: React.FC<any> = ({
  extraParams = {},
  defaultOptions,
  onRef,
  ...props
}) => {
  const fuzzyRef = useRef();
  const [data, setData] = useState();
  // 获取员工列表
  const loadData = async (name: string) => {
    const params = {
      name,
      ...extraParams,
    };
    const data = await getEmployee(params);
    setData(data);
    return Promise.resolve(data);
  };
  useImperativeHandle(onRef, () => ({
    getData() {
      return data;
    }
  }));
  useEffect(() => {
    if (!(isArray(defaultOptions) && defaultOptions.length)) return;
    (fuzzyRef as any).current.setOptions(defaultOptions); // 添加option项
  }, [defaultOptions]);
  return (
    <Fuzzy
      ref={fuzzyRef}
      loadData={loadData}
      fieldNames={{
        label: 'name',
        value: 'id'
      }}
      customOptionItem={(option) => {
        return `${option.name} ${option.mobile || ''} ${option.position || ''}`;
      }}
      optionLabelProp='label'
      {...props}
    />
  );
};

export default UserList;
